export default __webpack_public_path__ + "static/media/SWT0460.34I-42021_-25178_0.fe94da09.jpg";